import React from "react";
import "../../styles/CaseStudiesSection.css";

const CaseStudiesSection = () => {
    const caseStudies = [
        {
            title: "Launch More Content Without Hiring More People",
            challenge: "Marketing teams and agencies often hit a ceiling — too many deliverables, not enough time or writers.",
            solution: [
                "Use AI to generate blogs, social posts, and ad copy instantly.",
                "Define unique brand voices and audience profiles for each client.",
                "Plan and schedule campaigns in one shared content calendar."
            ],
            potentialOutcome:
                "You can double your content output and meet deadlines consistently — without hiring more people.",
        },
        {
            title: "Build a Full Funnel Without a Marketing Background",
            challenge: "Many business owners know they need marketing — but don't know where to start or what actually works.",
            solution: [
                "Launch AI-guided journeys that build funnels step-by-step.",
                "Use plug-and-play templates for social media, emails, and ads.",
                "Follow a proven flow from first post to first conversion."
            ],
            potentialOutcome:
                "You can launch a complete marketing system in days — even if you’ve never marketed before.",
        },
        {
            title: "Turn Website Traffic Into Leads on Autopilot",
            challenge: "Service-based businesses often get traffic — but miss conversions due to weak follow-up and generic messaging.",
            solution: [
                "Set up high-converting landing pages and smart email sequences.",
                "Deploy chatbots and automated follow-ups to engage leads in real-time.",
                "Create personalized content using AI, including voice and visuals."
            ],
            potentialOutcome:
                "You can turn site visitors into booked calls and clients — all while your automations run 24/7.",
        },
    ];


    return (
        <div className="case-studies-section">
            <h2 className="section-title">How We Empower Businesses Like Yours</h2>
            <p className="section-description">
                From fast-moving teams to solo founders, we build AI-powered systems that help you save time, increase output, and grow with less effort.
            </p>
            <div className="case-studies-container">
                {caseStudies.map((study, index) => (
                    <div className="case-study-card" key={index} data-aos="fade-up" data-aos-delay={`${index * 200}`}>
                        <h3 className="case-study-title">{study.title}</h3>
                        <p className="case-study-challenge"><strong>Challenge:</strong> {study.challenge}</p>
                        <div className="case-study-solution">
                            <strong>Solution:</strong>
                            <ul>
                                {study.solution.map((step, i) => (
                                    <li key={i}>{step}</li>
                                ))}
                            </ul>
                        </div>
                        <p className="case-study-outcome"><strong>Potential Outcome:</strong> {study.potentialOutcome}</p>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default CaseStudiesSection;